<template>
  <div>
    <button type="button" id="loginModalBtn" class="btn btn-primary waves-effect waves-light d-none" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Open modal</button>
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title" id="staticBackdropLabel">Sign in to continue</h5>
            <button type="button" id="loginModalCloseBtn" class="btn-close d-none" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="login()">
              <div class="alert alert-danger">Your session is expired. Login again to continue to dashboard</div>
              <div class="form-floating form-floating-custom mb-4">
                <select class="form-select" id="select-authtype" v-model="credentials.authType">
                  <option value="">Local Authentication</option>
                  <option value="">Ezemanage</option>
                </select>
                <label for="select-authtype">Authentication Type</label>
                <div class="form-floating-icon">
                  <eva-icon name="menu-outline"></eva-icon>
                </div>
              </div>

              <div class="form-floating form-floating-custom mb-4">
                <input type="text" class="form-control" id="input-username" placeholder="Username/Email" v-model="credentials.username" />
                <label for="input-username">Username / Email</label>
                <div class="form-floating-icon">
                  <eva-icon name="person-outline"></eva-icon>
                </div>
              </div>

              <div class="form-floating form-floating-custom mb-4 auth-pass-inputgroup">
                <input :type="showPassword ? 'text' : 'password'" class="form-control pe-5" id="password-input" placeholder="Password" v-model="credentials.password" />

                <button type="button" class="btn btn-link position-absolute h-100 end-0 top-0" id="password-addon" @click="togglePassword()">
                  <i class="mdi mdi-eye-outline font-size-18 text-muted"></i>
                </button>
                <label for="password-input">Password</label>
                <div class="form-floating-icon">
                  <eva-icon name="lock-outline"></eva-icon>
                </div>
              </div>

              <div class="mb-3">
                <button class="btn btn-primary w-100 waves-effect waves-light" @click.prevent="login()">Log In</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'
import { alertError } from '@/helpers/swal'
import { reactive, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
// import { getUserData } from "@/data/user.data";

const store = useStore()
const credentials = reactive({
  username: '',
  password: '',
  authType:'Local Authentication',
})
const showPassword = ref(false)

const togglePassword = () => {
  showPassword.value = !showPassword.value
}

onMounted(() => {
  document.querySelector('#loginModalBtn').click()
})

function login() {
  const url = `${window.authUrl}/signin/form`
  const params = new URLSearchParams(credentials)

  axios
    .post(url, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    .then((response) => {
      let user = response.data
      // user.permissions = [
      //   'dashboard',
      //   'system_admin',
      //   'system_admin_roles',
      //   'system_admin_roles_add',
      //   'system_admin_roles_edit',
      //   'system_admin_roles_delete',
      //   'system_admin_accounts',
      //   'system_admin_accounts_add',
      //   'system_admin_accounts_edit',
      //   'system_admin_accounts_delete',
      // ]
      store.dispatch('auth/authLogin', user)
      document.querySelector('#loginModalCloseBtn').click()
      const redirectPath = this.$route.query.redirectFrom || '/'
      window.location.href = redirectPath
    })
    .catch((error) => {
      alertError(error.response?.data?.message ?? error.message)
      console.error('Error:', error.response.data ?? error.message)
    })

  // const user = getUserData();
  // store.dispatch("auth/authLogin", user);
  // document.querySelector('#loginModalCloseBtn').click()
}
</script>
